import React from 'react';
import AppStoreImage from '../../assets/images/app-store.png';
import PlayStoreImage from '../../assets/images/play-store.png';
import './AppLinks.css';

export default function AppLinks({ data }) {
    const { appShow, title, googlePlayLink, appStoreLink } = data;

    if (!appShow) return null;

    return (
        <section className="appLinksContainer">
            <div>
                <h3 className="getAppTitle">{title}</h3>
            </div>
            <div className="rowImages">
                {googlePlayLink && renderLink(googlePlayLink, PlayStoreImage)}
                {appStoreLink && renderLink(appStoreLink, AppStoreImage)}
            </div>
        </section>
    );
}

function renderLink(href, imgSrc) {
    return (
        <a target="_blank" rel="noopener noreferrer" href={href} className="linkImage">
            <img src={imgSrc} alt="" />
        </a>
    );
}
